import { Link, createFileRoute } from "@tanstack/react-router"
import { Search } from "lucide-react"

import { Button } from "@/components/ui/button"
import { MemberShell } from "@/components/member-shell"
import { PropertyCard } from "@/components/property-display"
import { getFavoritesFn } from "@/lib/app.functions"
import { requireMemberRoute } from "@/lib/route-guards"

export const Route = createFileRoute("/favorites")({
  loader: async () => {
    await requireMemberRoute("/favorites")
    return getFavoritesFn()
  },
  head: () => ({
    meta: [{ title: "Saved properties · Harbor & Pine Realty" }],
  }),
  component: FavoritesPage,
})

function FavoritesPage() {
  const { user, properties } = Route.useLoaderData()
  return (
    <MemberShell
      user={user}
      eyebrow="Shortlist · saved state"
      title="Saved properties"
      intro="Keep the set intentionally small, then compare each property by the job it does and the evidence still missing."
      action={
        <Button
          className="field-button"
          nativeButton={false}
          render={<Link to="/search" />}
        >
          <Search />
          Find properties
        </Button>
      }
    >
      {properties.length ? (
        <div className="grid gap-5 xl:grid-cols-2">
          {properties.map((property) => (
            <PropertyCard key={property.id} property={property} signedIn />
          ))}
        </div>
      ) : (
        <div className="grid min-h-80 place-items-center border border-dashed bg-white p-8 text-center">
          <div>
            <h2 className="font-heading text-3xl uppercase">
              Your shortlist is clear
            </h2>
            <p className="mt-2 text-sm text-muted-foreground">
              Save a property from any search or detail sheet.
            </p>
          </div>
        </div>
      )}
    </MemberShell>
  )
}
